import React from "react";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import { FaFacebookF, FaTwitter, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "./Images/Final.png";

export default function Footer() {
  return (
    <footer className="relative bg-black text-white pt-20 pb-10 overflow-hidden border-t border-white/10">
      
      {/* Subtle Grid (kept very low opacity) */}
      <div 
        className="absolute inset-0 opacity-[0.04] pointer-events-none" 
        style={{
          backgroundImage: `linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          
          {/* Brand */}
          <div className="md:col-span-4">
            <img src={logo} alt="Logo" className="h-12 mb-6 brightness-0 invert" />
            <p className="text-gray-300 text-sm leading-relaxed max-w-xs mb-8">
              Empowering retailers with precision logistics and a robust wholesale network.
            </p>
            
            <div className="space-y-5">
              <a
                href="mailto:office@dailygolive.in"
                className="group flex items-center gap-4 text-[11px] font-bold uppercase tracking-widest text-gray-200 hover:text-yellow-500 transition"
              >
                <div className="p-2.5 bg-white/5 border border-white/10 group-hover:border-yellow-500/50">
                   <Mail className="h-4 w-4" />
                </div>
                office@dailygolive.in
              </a>

              <div className="flex items-start gap-4 text-[11px] font-bold uppercase tracking-widest text-gray-200">
                <div className="p-2.5 bg-white/5 border border-white/10">
                   <MapPin className="h-4 w-4" />
                </div>
                <span>
                   J. P. Nagar, Bengaluru, <br /> Karnataka 560078
                </span>
              </div>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-2">
            <h4 className="text-yellow-500 text-[10px] font-black uppercase tracking-[0.3em] mb-8">
              System Map
            </h4>
            <ul className="space-y-4 text-xs font-bold uppercase tracking-widest text-gray-400">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/AboutUsIndex" className="hover:text-white">About Us</Link></li>
              <li><Link to="/ServiceIndex" className="hover:text-white">Services</Link></li>
              <li><Link to="/BlogsIndex" className="hover:text-white">Insights</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-yellow-500 text-[10px] font-black uppercase tracking-[0.3em] mb-8">
              Support
            </h4>
            <ul className="space-y-4 text-xs font-bold uppercase tracking-widest text-gray-400">
              <li><Link to="/Comparison" className="hover:text-white">Pricing</Link></li>
              <li><Link to="/QuoteRequest" className="hover:text-white">Bulk Orders</Link></li>
              <li><Link to="/PrivacyPolicyIndex" className="hover:text-white">Privacy</Link></li>
              <li><Link to="/TermsAndConditionIndex" className="hover:text-white">Terms</Link></li>
            </ul>
          </div>

          {/* CTA */}
          <div className="md:col-span-4">
            <h4 className="text-yellow-500 text-[10px] font-black uppercase tracking-[0.3em] mb-8">
              Terminal Connect
            </h4>
            
            <a
              href="https://wa.me/916362022176"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between w-full border border-white/20 p-5 bg-white/5 hover:bg-yellow-500 hover:text-black transition group"
            >
              <div className="flex items-center gap-3">
                <FaWhatsapp className="text-xl" />
                <span className="text-[11px] font-black uppercase tracking-widest">
                  Connect to WhatsApp
                </span>
              </div>
              <ArrowUpRight className="h-4 w-4 group-hover:rotate-45 transition" />
            </a>

            <div className="mt-10 flex items-center justify-between">
              <div className="flex gap-3">
                {[FaInstagram, FaFacebookF, FaTwitter].map((Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="p-3 border border-white/10 text-gray-400 hover:text-yellow-500 hover:border-yellow-500 transition"
                  >
                    <Icon className="text-lg" />
                  </a>
                ))}
              </div>
              <span className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">
                Version 2.0.26
              </span>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">
            © 2026 Daily Go Live. All Operations Active.
          </p>
          <span className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">
            Bengaluru • India
          </span>
        </div>
      </div>
    </footer>
  );
}